export const emailValidator = (email: string): boolean => {
  const maxlength = 80;

  // eslint-disable-next-line no-useless-escape
  const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return email?.length <= maxlength && emailRegex.test(email);
};
